import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import ClientDetailsPage from "./ClientDetailsPage";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    backgroundColor: "transparent",
    boxShadow: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    width: "85%",
    zIndex: 0,
  },
  tab: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      "& .MuiBox-root": {
        padding: "0px",
        height: "70%",
      },
    },
  },
  largeIcon: {
    color: theme.palette.primary.main,
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  tabContainer: {
    marginLeft: "24px",
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function UserTabView() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="page-container">
      <Breadcrumb />
      <h1 className="page-title">Edit Careers Client</h1>
      <AppBar position="static" className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ indicator: classes.primary }}
          className={classes.tabContainer}
        >
          <Tab label="Edit Client" {...a11yProps(0)} className={classes.tab} />
          <Tab label="Client Connect" {...a11yProps(1)} className={classes.tab} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.tab}>
        <ClientDetailsPage />
      </TabPanel>
    </div>
  );
}
